export default {
  isLog: {
    empresa: localStorage.getItem('urlLogoPositivo'),
    token: localStorage.getItem('token')
  },
  cor: {
    cor2: `#${localStorage.getItem('corApp')}`,
    corSelecionado2: `#${localStorage.getItem('corSelecionado')}`,
    cor: `#${localStorage.getItem('corApp')}`,
    corSelecionado: {'background-color': `#${localStorage.getItem('corSelecionado')}`}
  },
  appData: {
    empresa: localStorage.getItem('empresaLogada'),
    dadosAcesso: localStorage.getItem('dadosAcesso')
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js